import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import SubTitle from "components/UI/Text/SubTitle";
import Image from "next/image";
import RegisterTextRow from "./RegisterTextRow";
import RegisterImage from "assets/images/register.png";
import AuthLogo from "components/Authentication/Logo";
import { useIntl } from "react-intl";

const RegisterLeftSide = () => {
  const intl = useIntl();
  return (
    <>
      <AuthLogo />
      <Grid container pl={3}>
        <Grid item xs={6} mt={10}>
          <SubTitle
            value={intl.formatMessage({
              id: "Index & Start Hiring Today",
              defaultMessage: "Index & Start Hiring Today",
            })}
            sx={{ pb: 5 }}
            fontWeight="700"
          />
          <Box mt={3}>
            <RegisterTextRow
              value={intl.formatMessage({
                id: "Post jobs in minutes",
                defaultMessage: "Post jobs in minutes",
              })}
            />
            <RegisterTextRow
              value={intl.formatMessage({
                id: "Search millions of CVs",
                defaultMessage: "Search millions of CVs",
              })}
            />
            <RegisterTextRow
              value={intl.formatMessage({
                id: "Get featured on multiple job boards",
                defaultMessage: "Get featured on multiple job boards",
              })}
            />
            <RegisterTextRow
              value={intl.formatMessage({
                id: "Find the right candidates",
                defaultMessage: "Find the right candidates",
              })}
            />
            <RegisterTextRow
              value={intl.formatMessage({
                id: "Connect with applicants on Live Chat",
                defaultMessage: "Connect with applicants on Live Chat",
              })}
            />
            <RegisterTextRow
              value={intl.formatMessage({
                id: "Schedule Interviews easily",
                defaultMessage: "Schedule Interviews easily",
              })}
            />
            <RegisterTextRow
              value={intl.formatMessage({
                id: "Manage applications all in one place",
                defaultMessage: "Manage applications all in one place",
              })}
            />
          </Box>
        </Grid>
        <Grid item xs={6} mt={10}>
          <Image
            src={RegisterImage}
            alt={intl.formatMessage({
              id: "GrabJobs Logo",
              defaultMessage: "GrabJobs Logo",
            })}
            layout="responsive"
            loading="lazy"
            width={560}
            height={700}
          />
        </Grid>
      </Grid>
      <Grid>
        <Grid item xs={9}>
          <Box
            sx={{ backgroundColor: "primary.main", padding: 2 }}
            borderRadius={1}
          >
            <Typography variant="h5" color="primary.light" fontWeight="bold">
              {intl.formatMessage({
                id: "Recruitment Automation Software",
                defaultMessage: "Recruitment Automation Software",
              })}
            </Typography>
            <Typography variant="body1" color="primary.light">
              {intl.formatMessage({
                id: "Join 20,000+ companies already using GrabJobs",
                defaultMessage: "Join 20,000+ companies already using GrabJobs",
              })}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default RegisterLeftSide;
